import { httpClient } from "@/lib/http-client"
import type { GeometeryType } from "@/lib/models"

export interface  FeatureType {
  id: string
  siteId: string
  name: string
  description: string | null
  featureCodeId: string
  reference: string | null
  subType: string
  types: Array<IFeatureType>
}

export interface IPolygonStyle {
  strokeColour: string
  strokeOpacity: number
  strokeWeight: number
  fillColour: string
  fillOpacity: number
}

export interface IPolylineStyle {
  strokeColour: string,
  strokeOpacity: number
  strokeWeight: number
}

export interface NewFeatureTypeRequest {
  siteId: string
  featureCodeId: string
  description: string | null
}

export interface UpdateFeatureTypeRequest {
  description: string | null
}

export interface IFeatureType{
  type: GeometeryType
}

export interface IPolygonFeatureType extends IFeatureType {
  style: IPolygonStyle
}

export interface IPolylineFeatureType extends IFeatureType {
  style: IPolylineStyle
}

export interface IPointFeatureType extends IFeatureType {
  style: IPolylineStyle
}

export interface IAnnulusFeatureType extends IFeatureType {
  style: IPolygonStyle
}

export class FeatureTypeService {
  private static readonly BASE_PATH = "/api/featuretypes"

  static async create(feature: NewFeatureTypeRequest): Promise<FeatureType> {
    return httpClient.post<FeatureType>(`${this.BASE_PATH}`, feature)
  }

  static async update(featureId: string, feature: UpdateFeatureTypeRequest): Promise<void> {
    return httpClient.put<void>(`${this.BASE_PATH}/${featureId}`, feature)
  }

  static async delete(featureTypeId: string): Promise<void> {
    return httpClient.delete<void>(`${this.BASE_PATH}/${featureTypeId}`)
  }

  static async getById(featureTypeId: string): Promise<FeatureType> {
    return httpClient.get<FeatureType>(`${this.BASE_PATH}/${featureTypeId}`)
  }

  static async getBySiteId(siteId: string): Promise<FeatureType[]> {
    return httpClient.get<FeatureType[]>(`${this.BASE_PATH}/sites/${siteId}`)
  }
}
